import PropTypes from 'prop-types';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import ArgonButton from 'component/Argon/ArgonButton';

const Props = {
  data: PropTypes.any.isRequired,
  fileName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

/** @param {PropTypes.InferProps<typeof Props>} props */
function ExportToExcel({ data, fileName, disabled, children }) {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (apiData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <ArgonButton variant="gradient" color="info" size="small"
      disabled={disabled}
      onClick={() => exportToCSV(data, fileName)}
    >
      {children || 'Export'}
    </ArgonButton>
  );
};

ExportToExcel.propTypes = Props;

export default ExportToExcel;